import React from 'react';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown'


const NavDropdownResearch = ({ articles }) => (
    <>
    {articles.map((article, key) => (
        <NavDropdown.Item as={Link} key={key} to={`/research/${article.name}`}>{article.title}</NavDropdown.Item>
    ))}
    </>
);

export default NavDropdownResearch;